<template>
	<section class="consultation-section">
		<div class="container">
			<div class="section-header center">
				<h2 class="section-title">{{ $t('consultationSection.sectionTitle') }}</h2>
				<p class="section-description">{{$t('consultationSection.sectionDescription')}}</p>
			</div>

			<div class="cards-container">
				<!-- 数据库服务卡片 -->
				<div class="service-card">
					<div class="card-visual">
						<svg class="card-icon" viewBox="0 0 24 24">
							<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z" />
							<path d="M7 12h2v2H7zm0-4h2v2H7zm4 4h2v2h-2zm0-4h2v2h-2zm4 4h2v2h-2zm0-4h2v2h-2z" />
						</svg>
						<div class="visual-effects">
							<div class="effect-circle blue"></div>
							<div class="effect-circle green"></div>
						</div>
					</div>
					<div class="card-content">
						<span class="card-category">{{$t('consultationSection.services.dataService.category')}}</span>
						<h3 class="card-title">{{$t('consultationSection.services.dataService.title')}}</h3>
						<ul class="feature-list">
							<li v-for="(feature, index) in $t('consultationSection.services.dataService.features')"
								:key="'certification-' + index">
								<svg class="feature-icon" viewBox="0 0 24 24">
									<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
								</svg>
								{{ feature }}
							</li>
						</ul>
					</div>
				</div>

				<!-- 认证服务卡片 -->
				<div class="service-card">
					<div class="card-visual">
						<svg class="card-icon" viewBox="0 0 24 24">
							<path
								d="M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm-1.06 13.54L7.4 12l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41-5.64 5.66z" />
						</svg>
						<div class="visual-effects">
							<div class="effect-circle blue"></div>
							<div class="effect-circle green"></div>
						</div>
					</div>
					<div class="card-content">
						<span class="card-category">{{$t('consultationSection.services.certificationService.category')}}</span>
						<h3 class="card-title">{{$t('consultationSection.services.certificationService.title')}}</h3>
						<ul class="feature-list">
							<li v-for="(feature, index) in $t('consultationSection.services.certificationService.features')"
								:key="'certification-' + index">
								<svg class="feature-icon" viewBox="0 0 24 24">
									<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
								</svg>
								{{ feature }}
							</li>
						</ul>
					</div>
				</div>

				<!-- 移动应用卡片 -->
				<!-- 优化后的移动应用卡片 -->
				<!-- 移动应用卡片（统一为认证服务风格） -->
				<div class="service-card">
					<div class="card-visual">
						<svg class="card-icon" viewBox="0 0 24 24" fill="#4A90E2">
							<path
								d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5.01 5L21 19.49l-5-5zM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
						</svg>
						<div class="visual-effects">
							<div class="effect-circle blue"></div>
							<div class="effect-circle green"></div>
						</div>
					</div>

					<div class="card-content">
						<span class="card-category">{{$t('consultationSection.services.mobileApp.category')}}</span>
						<h3 class="card-title">{{$t('consultationSection.services.mobileApp.title')}}</h3>
						<ul class="feature-list">
							<li v-for="(feature, index) in $t('consultationSection.services.mobileApp.features')"
								:key="'certification-' + index">
								<svg class="feature-icon" viewBox="0 0 24 24">
									<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
								</svg>
								{{ feature }}
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="partners-section">
				<h3 class="partners-title">{{$t('consultationSection.partnersSectionTitle')}}</h3>
				<div class="partners-grid">
					<div class="partner-item" v-for="(partner, index) in $t('consultationSection.partners')" :key="index">
						<div class="partner-logo">
							<img :src="getPartnerImage(index)" :alt="partner.alt" />
						</div>
						<span class="partner-name">{{ partner.name }}</span>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'ConsultationServices',
		methods: {
			getPartnerImage(index) {
				const imageMap = [
					require('@/assets/images/dgm.png'),
					require('@/assets/images/xn.jpg'),
					require('@/assets/images/shhg.png'),
					require('@/assets/images/mhes.png'),
					require('@/assets/images/tjjj.jpg')
				];
				return imageMap[index] || '';
			}
		}
	};
</script>

<style scoped>
	.consultation-section {
		/* background: linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%); */
		padding: 5rem 0;
		position: relative;
		overflow: hidden;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 1.5rem;
	}

	.section-header {
		margin-bottom: 80px;

		&.center {
			text-align: center;
		}

		.section-title {
			font-size: 42px;
			font-weight: 600;
			margin-bottom: 15px;
			color: #1a3e72;
			position: relative;
			display: inline-block;

			&::after {
				content: '';
				position: absolute;
				bottom: -15px;
				left: 0;
				width: 80px;
				height: 4px;
				background: linear-gradient(to right, #1a6fdf, #4facfe);
				border-radius: 2px;
			}
		}

		.section-subtitle {
			font-size: 18px;
			color: #6c757d;
			font-weight: 300;
			letter-spacing: 1px;
		}
	}

	.title-icon {
		width: 1.75rem;
		height: 1.75rem;
		fill: #4fc3f7;
	}

	.section-description {
		font-size: 1.125rem;
		color: #546e7a;
		max-width: 40rem;
		margin: 0 auto;
		line-height: 1.6;
	}

	.cards-container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		gap: 1.5rem;
		margin-bottom: 3rem;
	}

	.service-card {
		background: white;
		border-radius: 1rem;
		box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
		overflow: hidden;
		display: flex;
		flex-direction: column;
		transition: transform 0.3s ease, box-shadow 0.3s ease;
		position: relative;
		border: 1px solid rgba(0, 0, 0, 0.05);
	}

	.service-card:hover {
		transform: translateY(-0.5rem);
		box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08);
	}

	.card-visual {
		height: 12rem;
		position: relative;
		overflow: hidden;
		background: linear-gradient(135deg, #f5fbfe 0%, #e8f5e9 100%);
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 1.5rem;
	}

	.app-card .card-visual {
		background: linear-gradient(135deg, #e3f2fd 0%, #e8f5e9 100%);
	}

	.card-icon {
		width: 5rem;
		height: 5rem;
		fill: #4fc3f7;
		position: relative;
		z-index: 2;
	}

	.visual-effects {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}

	.effect-circle {
		position: absolute;
		border-radius: 50%;
		opacity: 0.1;
	}

	.effect-circle.blue {
		background: #4fc3f7;
		width: 8rem;
		height: 8rem;
		top: -2rem;
		right: -2rem;
	}

	.effect-circle.green {
		background: #81c784;
		width: 5rem;
		height: 5rem;
		bottom: 1rem;
		left: 1rem;
	}

	.card-content {
		padding: 1.5rem;
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.card-category {
		align-self: flex-start;
		background-color: #f5fbfe;
		color: #4fc3f7;
		font-size: 0.75rem;
		font-weight: 600;
		padding: 0.25rem 0.75rem;
		border-radius: 0.75rem;
		margin-bottom: 1rem;
	}

	.card-title {
		font-size: 1.25rem;
		font-weight: 600;
		color: #1a237e;
		margin: 0 0 0.75rem;
	}

	.card-text {
		font-size: 0.9375rem;
		color: #546e7a;
		line-height: 1.6;
		margin-bottom: 1.25rem;
	}

	.feature-list {
		list-style: none;
		padding: 0;
		margin: 0 0 1.25rem;
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}

	.feature-list li {
		font-size: 0.875rem;
		color: #455a64;
		display: flex;
		align-items: flex-start;
		gap: 0.5rem;
	}

	.feature-icon {
		width: 1rem;
		height: 1rem;
		fill: #81c784;
		flex-shrink: 0;
		margin-top: 0.125rem;
	}

	.action-button {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background-color: #4fc3f7;
		color: white;
		border: none;
		padding: 0.75rem 1.25rem;
		border-radius: 0.5rem;
		font-size: 0.875rem;
		font-weight: 600;
		margin-top: auto;
		cursor: pointer;
		transition: all 0.3s ease;
		gap: 0.5rem;
	}

	.action-button:hover {
		background-color: #3ab0d8;
		transform: translateY(-2px);
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	}

	.button-icon {
		width: 1rem;
		height: 1rem;
		fill: currentColor;
	}

	/* 应用卡片特殊样式 */
	.app-card {
		display: flex;
		flex-direction: column;
		background: #fff;
		border-radius: 20px;
		overflow: hidden;
		box-shadow: 0 12px 32px rgba(0, 0, 0, 0.06);
		transition: transform 0.3s ease;

		&:hover {
			transform: translateY(-6px);
		}

		.card-visual {
			position: relative;
			background: linear-gradient(135deg, #e6f0ff, #f5faff);
			padding: 20px;
			display: flex;
			justify-content: center;

			.app-mockup {
				background: #fff;
				border-radius: 24px;
				box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
				padding: 16px;
				width: 240px;

				.app-screen {
					.app-header {
						display: flex;
						align-items: center;
						margin-bottom: 12px;

						.app-icon {
							width: 36px;
							height: 36px;
							background: #007bff;
							border-radius: 50%;
							display: flex;
							align-items: center;
							justify-content: center;
							margin-right: 10px;

							.feature-icon {
								width: 20px;
								height: 20px;
								fill: #fff;
							}
						}

						h4 {
							font-size: 16px;
							color: #333;
						}
					}

					.app-preview-text {
						p {
							font-size: 13px;
							color: #555;
							margin-bottom: 8px;
						}

						.app-tags {
							list-style: none;
							padding: 0;
							display: flex;
							flex-wrap: wrap;
							gap: 6px;

							li {
								background: #e0f0ff;
								color: #007bff;
								padding: 4px 10px;
								border-radius: 12px;
								font-size: 12px;
							}
						}
					}
				}
			}

			.visual-effects {
				.effect-circle {
					position: absolute;
					border-radius: 50%;
					opacity: 0.4;
					animation: float 6s infinite ease-in-out alternate;

					&.blue {
						width: 100px;
						height: 100px;
						background: #007bff;
						top: 10px;
						left: -30px;
					}

					&.green {
						width: 60px;
						height: 60px;
						background: #28a745;
						bottom: 0;
						right: 20px;
					}
				}
			}
		}

		.card-content {
			padding: 24px;

			.card-category {
				font-size: 13px;
				font-weight: bold;
				color: #007bff;
				text-transform: uppercase;
				margin-bottom: 6px;
			}

			.card-title {
				font-size: 20px;
				font-weight: bold;
				color: #333;
				margin-bottom: 10px;
			}

			.card-text {
				font-size: 14px;
				color: #555;
				margin-bottom: 20px;
			}

			.app-stats {
				display: flex;
				gap: 30px;

				.stat-item {
					.stat-value {
						font-size: 18px;
						font-weight: bold;
						color: #007bff;
					}

					.stat-label {
						font-size: 12px;
						color: #888;
					}
				}
			}
		}
	}

	@keyframes float {
		0% {
			transform: translateY(0px);
		}

		100% {
			transform: translateY(15px);
		}
	}

	/* 合作伙伴部分 */
	.partners-section {
		margin-top: 3rem;
		text-align: center;
	}

	.partners-title {
		font-size: 1.125rem;
		color: #607d8b;
		margin-bottom: 1.25rem;
		position: relative;
		display: inline-block;
	}

	.partners-title::after {
		content: '';
		position: absolute;
		bottom: -0.5rem;
		left: 50%;
		transform: translateX(-50%);
		width: 2.5rem;
		height: 2px;
		background-color: #4fc3f7;
	}

	.partners-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
		gap: 1.5rem;
		margin-top: 1.5rem;
	}

	.partner-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.5rem;
		cursor: pointer;
	}

	.partner-logo {
		width: 5rem;
		/* 或原来的 3rem 也可以，根据图片比例调整 */
		height: 5rem;
		background: #fff;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0.75rem;
		transition: all 0.3s ease;
		overflow: hidden;
		/* 防止图片溢出圆形边框 */
	}

	.partner-logo img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
		transition: all 0.3s ease;
		opacity: 0.8;
	}

	.partner-item:hover .partner-logo {
		background: #e3f2fd;
		transform: scale(1.1);
	}

	.partner-item:hover .partner-logo img {
		opacity: 1;
	}


	.partner-name {
		font-size: 0.75rem;
		color: #78909c;
		opacity: 0;
		transition: opacity 0.3s ease;
	}

	.partner-item:hover .partner-name {
		opacity: 1;
	}

	/* 响应式调整 */
	@media (max-width: 1024px) {
		.cards-container {
			grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
		}
	}

	@media (max-width: 768px) {
		.section-title {
			font-size: 1.75rem;
		}

		.section-description {
			font-size: 1rem;
		}

		.partners-grid {
			grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
		}
	}

	@media (max-width: 480px) {
		.consultation-section {
			padding: 3rem 0;
		}

		.container {
			padding: 0 1rem;
		}

		.section-title {
			font-size: 1.5rem;
		}

		.cards-container {
			grid-template-columns: 1fr;
		}

		.download-buttons {
			flex-direction: column;
		}
	}
</style>